import React, { lazy, Suspense, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spinner, Alert } from "react-bootstrap";
import Header from "../SpanishPage/Header/index.js";
import Body from "../SpanishPage/Body/Body";
import Footer from "../SpanishPage/FooterNewilena/index.js";
import SpanishPRJsonData from "../Spanish-wholesale-lending-pr.json";

// Lazy-loaded components
// const Lodetails = lazy(() => import("./components/Lodetails/lodetails.js"));
const Presence = lazy(() => import("../SpanishPage/Presence/presence.js"));
const ProductSection = lazy(() => import("../SpanishPage/ProductSection/product.js"));
const Presentations = lazy(() => import("../SpanishPage/Presentation/presentation.js"));
const LogoSection = lazy(() => import("../SpanishPage/Logo Section/NewLogoSection.js"));
const TableData = lazy(() => import("../SpanishPage/Table/table.js"));
const Testimonials = lazy(() => import("../SpanishPage/Testimonials/testimonial.js"));
const SWMCBroker = lazy(() => import("../SpanishPage/SWMCBroker/swmcbroker.js"));
const FAQ = lazy(() => import("../SpanishPage/FAQ/faq.js"));

function SpanishHomePage() {
  const { agentName } = useParams();
  const [isSpanish, setIsSpanish] = useState(false); // Default to English
  const toggleLanguage = () => {
    setIsSpanish(!isSpanish); // Toggle the language state
  };
  
  const handleLanguageChange = (isSpanish) => {
    setIsSpanish(isSpanish);
  };

  const fetchData = async () => {
    try {
      const jsonData = isSpanish
        ? SpanishPRJsonData
        : null; // Set jsonData to null for English

      if (jsonData) {
        // Set state variables based on the fetched JSON data
        setBannerData(jsonData.bannerData);
        setPresenceData(jsonData.presenceData);
        setProductData(jsonData.productData);
        setLogoData(jsonData.logoData);
        setTableData(jsonData.tableData);
        setTestimonialData(jsonData.testimonialData);
        setBrokerData(jsonData.brokerData);
        setFaqData(jsonData.faqData);
      }
      
      // Other data setting logic...
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Error fetching data");
    }
  };

  useEffect(() => {
    fetchData(); // Fetch JSON data based on the language toggle
  }, [isSpanish]); // Add isSpanish to the dependency array

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loanOfficerActive, setLoanOfficerActive] = useState(true);
  const [loanOfficerData, setLoanOfficerData] = useState();
  const [angelAiUserInfo, setAngelAiUserInfo] = useState();
  const [bannerData, setBannerData] = useState(); // State for bannerData
  const [presenceData, setPresenceData] = useState(); // State for bannerData
  const [productData, setProductData] = useState(); // State for bannerData
  const [logoData, setLogoData] = useState(); // State for bannerData
  const [tableData, setTableData] = useState(); // State for bannerData
  const [testimonialData, setTestimonialData] = useState(); // State for bannerData
  const [brokerData, setBrokerData] = useState(); // State for bannerData
  const [faqData, setFaqData] = useState(); // State for bannerData

  // Function to handle loan officer click
  const handleLoanOfficerClick = (loanOfficerData) => {
    setLoanOfficerData(loanOfficerData);
    setLoanOfficerActive(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Simulate fetching data (replace with actual fetching logic)
        // In this example, we set the bannerData after a delay to simulate data fetching
        await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate delay
        setBannerData(SpanishPRJsonData.bannerData); // Set bannerData from SpanishPRJsonData
        setPresenceData(SpanishPRJsonData.presenceData); // Set bannerData from SpanishPRJsonData
        setProductData(SpanishPRJsonData.productData); // Set bannerData from SpanishPRJsonData
        setLogoData(SpanishPRJsonData.logoData); // Set bannerData from SpanishPRJsonData
        setTableData(SpanishPRJsonData.tableData); // Set bannerData from SpanishPRJsonData
        setTestimonialData(SpanishPRJsonData.testimonialData); // Set bannerData from SpanishPRJsonData
        setBrokerData(SpanishPRJsonData.brokerData); // Set bannerData from SpanishPRJsonData
        setFaqData(SpanishPRJsonData.faqData); // Set bannerData from SpanishPRJsonData

        // Additional data fetching and setting state logic goes here...

        setLoading(false); // Set loading to false after data fetching
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Error fetching data"); // Set error state
        setLoading(false); // Set loading to false on error
      }
    };

    fetchData();
  }, []);

  return (
    <div className="bodyContainer">
      <Suspense fallback={<Spinner animation="border" />}>
        {error && <Alert variant="danger">{error}</Alert>}
        {loading ? (
          <div className="mt-5 mb-3 text-center">
            <Spinner animation="border" />
            <h5>Loading...</h5>
          </div>
        ) : (
          <>
            <Header
              toggleLanguage={toggleLanguage} // Use toggleLanguage instead of handleLanguageChange
              handleLanguageChange={handleLanguageChange} // Pass handleLanguageChange
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <Body
              bannerData={bannerData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <Presence
              presenceData={presenceData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <ProductSection
              productData={productData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <TableData
              tableData={tableData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <LogoSection
              logoData={logoData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <Testimonials
              testimonialData={testimonialData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <SWMCBroker
              brokerData={brokerData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <FAQ
              faqData={faqData} // Pass bannerData to Body component
              loanOfficerActive={loanOfficerActive}
              loanOfficerData={loanOfficerData}
              angelAiUserInfo={angelAiUserInfo}
            />
            <Footer />
          </>
        )}
      </Suspense>
    </div>
  );
}

export default SpanishHomePage;
